"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
const TruncatedTextArea = _ref => {
  let {
    preserveNewlines,
    truncateConfig,
    value
  } = _ref;
  const {
    maxHeight,
    showLessText,
    showMoreText,
    showTextStyle,
    valueTextStyle
  } = truncateConfig;
  const theme = (0, _material.useTheme)();
  const [showAll, setShowAll] = (0, _react.useState)(false);
  const [needsTruncating, setNeedsTruncating] = (0, _react.useState)(false);
  const [totalHeight, setTotalHeight] = (0, _react.useState)(0);
  const ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (ref && ref.current && !totalHeight) {
      const height = ref.current.clientHeight;
      setTotalHeight(height);
      setNeedsTruncating(height > maxHeight);
    }
  }, [maxHeight, ref, totalHeight]);
  const toggleShowAll = () => setShowAll(prev => !prev);
  const textStyle = {
    ...valueTextStyle,
    margin: '8px 0',
    padding: 0,
    overflow: 'hidden',
    width: '100%'
  };
  if (needsTruncating && !showAll) {
    textStyle.maxHeight = "".concat(maxHeight, "px");
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    ref: ref,
    className: "textfield-value--display".concat(preserveNewlines ? ' preserve-newlines' : ''),
    style: textStyle
  }, value), needsTruncating && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_material.Link, {
    component: "button",
    onClick: toggleShowAll,
    onBlur: () => setShowAll(false),
    sx: {
      color: theme.palette.TwClrTxtBrand,
      textDecorationColor: "".concat(theme.palette.TwClrTxtBrand, "80")
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      ...showTextStyle,
      marginTop: '-3px'
    }
  }, showAll ? showLessText : showMoreText))));
};
var _default = exports.default = TruncatedTextArea;